// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Redirect = require("../../reason/common/Redirect.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let Form__Label = require("../common/Components/Form__Label.bs.js");
let FormalityUI = require("../common/Components/FormalityUI.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Form__TextInput = require("../common/Components/Form__TextInput.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let UnifiedProfileSave = require("./UnifiedProfileSave.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let UnifiedProfileSettingsUI = require("./UnifiedProfileSettingsUI.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let UnifiedProfileSocialValidation = require("./UnifiedProfileSocialValidation.bs.js");
let UnifiedTeamAccountProfileSocialMediaSettingsQuery_graphql = require("../../__generated__/UnifiedTeamAccountProfileSocialMediaSettingsQuery_graphql.bs.js");
let UnifiedTeamAccountProfileSocialMediaSettingsSocialsMutation_graphql = require("../../__generated__/UnifiedTeamAccountProfileSocialMediaSettingsSocialsMutation_graphql.bs.js");

let convertVariables = UnifiedTeamAccountProfileSocialMediaSettingsSocialsMutation_graphql.Internal.convertVariables;

let convertResponse = UnifiedTeamAccountProfileSocialMediaSettingsSocialsMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedTeamAccountProfileSocialMediaSettingsSocialsMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, UnifiedTeamAccountProfileSocialMediaSettingsSocialsMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, UnifiedTeamAccountProfileSocialMediaSettingsSocialsMutation_graphql.node, convertResponse, convertWrapRawResponse);

let SocialsMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function useSocials() {
  let match = use();
  let commit = match[0];
  return UnifiedProfileSave.useAccountSave(match[1], (input, onCompleted, onError) => commit({
    input: input
  }, undefined, undefined, undefined, onCompleted, onError, undefined), response => {
    let match = response.updateUnifiedTeamSocialAccounts;
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "The profile could not be saved. Please try again."
      };
    }
    switch (match.__typename) {
      case "UpdateUnifiedAccountProfilePayload" :
        return {
          TAG: "Ok",
          _0: match.profile
        };
      case "__unselected" :
        return {
          TAG: "Error",
          _0: "The profile could not be saved. Please try again."
        };
      default:
        return {
          TAG: "Error",
          _0: match.message
        };
    }
  });
}

let validators_linkedIn = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: param => UnifiedProfileSocialValidation.linkedIn(param.linkedIn)
};

let validators = {
  twitter: undefined,
  facebook: undefined,
  instagram: undefined,
  linkedIn: validators_linkedIn,
  youTube: undefined,
  tikTok: undefined,
  yelp: undefined
};

function initialFieldsStatuses(input) {
  return {
    twitter: "Pristine",
    facebook: "Pristine",
    instagram: "Pristine",
    linkedIn: "Pristine",
    youTube: "Pristine",
    tikTok: "Pristine",
    yelp: "Pristine"
  };
}

let initialFieldStatuses_xxx = initialFieldsStatuses;

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: initialFieldsStatuses(input),
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses) {
  let match_0 = {
    TAG: "Ok",
    _0: input.twitter
  };
  let match_0$1 = {
    TAG: "Ok",
    _0: input.facebook
  };
  let match_0$2 = {
    TAG: "Ok",
    _0: input.instagram
  };
  let match = fieldsStatuses.linkedIn;
  let tmp;
  tmp = typeof match !== "object" ? validators.linkedIn.validate(input) : match._0;
  let match_0$3 = {
    TAG: "Ok",
    _0: input.youTube
  };
  let match_0$4 = {
    TAG: "Ok",
    _0: input.tikTok
  };
  let match_0$5 = {
    TAG: "Ok",
    _0: input.yelp
  };
  let twitterResult = match_0;
  let twitterResult$1;
  if (twitterResult.TAG === "Ok") {
    let facebookResult = match_0$1;
    if (facebookResult.TAG === "Ok") {
      let instagramResult = match_0$2;
      if (instagramResult.TAG === "Ok") {
        let linkedInResult = tmp;
        if (linkedInResult.TAG === "Ok") {
          let youTubeResult = match_0$3;
          if (youTubeResult.TAG === "Ok") {
            let tikTokResult = match_0$4;
            if (tikTokResult.TAG === "Ok") {
              let yelpResult = match_0$5;
              if (yelpResult.TAG === "Ok") {
                return {
                  TAG: "Valid",
                  output: {
                    twitter: twitterResult._0,
                    facebook: facebookResult._0,
                    instagram: instagramResult._0,
                    linkedIn: linkedInResult._0,
                    youTube: youTubeResult._0,
                    tikTok: tikTokResult._0,
                    yelp: yelpResult._0
                  },
                  fieldsStatuses: {
                    twitter: {
                      TAG: "Dirty",
                      _0: twitterResult,
                      _1: "Hidden"
                    },
                    facebook: {
                      TAG: "Dirty",
                      _0: facebookResult,
                      _1: "Hidden"
                    },
                    instagram: {
                      TAG: "Dirty",
                      _0: instagramResult,
                      _1: "Hidden"
                    },
                    linkedIn: {
                      TAG: "Dirty",
                      _0: linkedInResult,
                      _1: "Shown"
                    },
                    youTube: {
                      TAG: "Dirty",
                      _0: youTubeResult,
                      _1: "Hidden"
                    },
                    tikTok: {
                      TAG: "Dirty",
                      _0: tikTokResult,
                      _1: "Hidden"
                    },
                    yelp: {
                      TAG: "Dirty",
                      _0: yelpResult,
                      _1: "Hidden"
                    }
                  },
                  collectionsStatuses: undefined
                };
              }
              twitterResult$1 = twitterResult;
            } else {
              twitterResult$1 = twitterResult;
            }
          } else {
            twitterResult$1 = twitterResult;
          }
        } else {
          twitterResult$1 = twitterResult;
        }
      } else {
        twitterResult$1 = twitterResult;
      }
    } else {
      twitterResult$1 = twitterResult;
    }
  } else {
    twitterResult$1 = twitterResult;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      twitter: {
        TAG: "Dirty",
        _0: twitterResult$1,
        _1: "Hidden"
      },
      facebook: {
        TAG: "Dirty",
        _0: match_0$1,
        _1: "Hidden"
      },
      instagram: {
        TAG: "Dirty",
        _0: match_0$2,
        _1: "Hidden"
      },
      linkedIn: {
        TAG: "Dirty",
        _0: tmp,
        _1: "Shown"
      },
      youTube: {
        TAG: "Dirty",
        _0: match_0$3,
        _1: "Hidden"
      },
      tikTok: {
        TAG: "Dirty",
        _0: match_0$4,
        _1: "Hidden"
      },
      yelp: {
        TAG: "Dirty",
        _0: match_0$5,
        _1: "Hidden"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurTwitterField" :
          let result = Formality.validateFieldOnBlurWithoutValidator(state.input.twitter, state.fieldsStatuses.twitter, status => {
            let init = state.fieldsStatuses;
            return {
              twitter: status,
              facebook: init.facebook,
              instagram: init.instagram,
              linkedIn: init.linkedIn,
              youTube: init.youTube,
              tikTok: init.tikTok,
              yelp: init.yelp
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurFacebookField" :
          let result$1 = Formality.validateFieldOnBlurWithoutValidator(state.input.facebook, state.fieldsStatuses.facebook, status => {
            let init = state.fieldsStatuses;
            return {
              twitter: init.twitter,
              facebook: status,
              instagram: init.instagram,
              linkedIn: init.linkedIn,
              youTube: init.youTube,
              tikTok: init.tikTok,
              yelp: init.yelp
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurInstagramField" :
          let result$2 = Formality.validateFieldOnBlurWithoutValidator(state.input.instagram, state.fieldsStatuses.instagram, status => {
            let init = state.fieldsStatuses;
            return {
              twitter: init.twitter,
              facebook: init.facebook,
              instagram: status,
              linkedIn: init.linkedIn,
              youTube: init.youTube,
              tikTok: init.tikTok,
              yelp: init.yelp
            };
          });
          if (result$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$2,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurLinkedInField" :
          let result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.linkedIn, validators_linkedIn, status => {
            let init = state.fieldsStatuses;
            return {
              twitter: init.twitter,
              facebook: init.facebook,
              instagram: init.instagram,
              linkedIn: status,
              youTube: init.youTube,
              tikTok: init.tikTok,
              yelp: init.yelp
            };
          });
          if (result$3 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$3,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurYouTubeField" :
          let result$4 = Formality.validateFieldOnBlurWithoutValidator(state.input.youTube, state.fieldsStatuses.youTube, status => {
            let init = state.fieldsStatuses;
            return {
              twitter: init.twitter,
              facebook: init.facebook,
              instagram: init.instagram,
              linkedIn: init.linkedIn,
              youTube: status,
              tikTok: init.tikTok,
              yelp: init.yelp
            };
          });
          if (result$4 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$4,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurTikTokField" :
          let result$5 = Formality.validateFieldOnBlurWithoutValidator(state.input.tikTok, state.fieldsStatuses.tikTok, status => {
            let init = state.fieldsStatuses;
            return {
              twitter: init.twitter,
              facebook: init.facebook,
              instagram: init.instagram,
              linkedIn: init.linkedIn,
              youTube: init.youTube,
              tikTok: status,
              yelp: init.yelp
            };
          });
          if (result$5 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$5,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurYelpField" :
          let result$6 = Formality.validateFieldOnBlurWithoutValidator(state.input.yelp, state.fieldsStatuses.yelp, status => {
            let init = state.fieldsStatuses;
            return {
              twitter: init.twitter,
              facebook: init.facebook,
              instagram: init.instagram,
              linkedIn: init.linkedIn,
              youTube: init.youTube,
              tikTok: init.tikTok,
              yelp: status
            };
          });
          if (result$6 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$6,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Primitive_option.some(error._0);
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateTwitterField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput.twitter, status => {
                let init = state.fieldsStatuses;
                return {
                  twitter: status,
                  facebook: init.facebook,
                  instagram: init.instagram,
                  linkedIn: init.linkedIn,
                  youTube: init.youTube,
                  tikTok: init.tikTok,
                  yelp: init.yelp
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateFacebookField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$1.facebook, status => {
                let init = state.fieldsStatuses;
                return {
                  twitter: init.twitter,
                  facebook: status,
                  instagram: init.instagram,
                  linkedIn: init.linkedIn,
                  youTube: init.youTube,
                  tikTok: init.tikTok,
                  yelp: init.yelp
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateInstagramField" :
          let nextInput$2 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$2,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$2.instagram, status => {
                let init = state.fieldsStatuses;
                return {
                  twitter: init.twitter,
                  facebook: init.facebook,
                  instagram: status,
                  linkedIn: init.linkedIn,
                  youTube: init.youTube,
                  tikTok: init.tikTok,
                  yelp: init.yelp
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateLinkedInField" :
          let nextInput$3 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$3,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, state.fieldsStatuses.linkedIn, state.submissionStatus, validators_linkedIn, status => {
                let init = state.fieldsStatuses;
                return {
                  twitter: init.twitter,
                  facebook: init.facebook,
                  instagram: init.instagram,
                  linkedIn: status,
                  youTube: init.youTube,
                  tikTok: init.tikTok,
                  yelp: init.yelp
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateYouTubeField" :
          let nextInput$4 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$4,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$4.youTube, status => {
                let init = state.fieldsStatuses;
                return {
                  twitter: init.twitter,
                  facebook: init.facebook,
                  instagram: init.instagram,
                  linkedIn: init.linkedIn,
                  youTube: status,
                  tikTok: init.tikTok,
                  yelp: init.yelp
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateTikTokField" :
          let nextInput$5 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$5,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$5.tikTok, status => {
                let init = state.fieldsStatuses;
                return {
                  twitter: init.twitter,
                  facebook: init.facebook,
                  instagram: init.instagram,
                  linkedIn: init.linkedIn,
                  youTube: init.youTube,
                  tikTok: status,
                  yelp: init.yelp
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateYelpField" :
          let nextInput$6 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$6,
              fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$6.yelp, status => {
                let init = state.fieldsStatuses;
                return {
                  twitter: init.twitter,
                  facebook: init.facebook,
                  instagram: init.instagram,
                  linkedIn: init.linkedIn,
                  youTube: init.youTube,
                  tikTok: init.tikTok,
                  yelp: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: initialFieldsStatuses(input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: initialFieldsStatuses(state.input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: Primitive_option.some(map(Primitive_option.valFromOption(error$2)))
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateTwitter: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateTwitterField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateFacebook: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateFacebookField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateInstagram: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateInstagramField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateLinkedIn: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateLinkedInField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateYouTube: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateYouTubeField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateTikTok: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateTikTokField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateYelp: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateYelpField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurTwitter: () => dispatch("BlurTwitterField"),
    blurFacebook: () => dispatch("BlurFacebookField"),
    blurInstagram: () => dispatch("BlurInstagramField"),
    blurLinkedIn: () => dispatch("BlurLinkedInField"),
    blurYouTube: () => dispatch("BlurYouTubeField"),
    blurTikTok: () => dispatch("BlurTikTokField"),
    blurYelp: () => dispatch("BlurYelpField"),
    twitterResult: Formality.exposeFieldResult(state.fieldsStatuses.twitter),
    facebookResult: Formality.exposeFieldResult(state.fieldsStatuses.facebook),
    instagramResult: Formality.exposeFieldResult(state.fieldsStatuses.instagram),
    linkedInResult: Formality.exposeFieldResult(state.fieldsStatuses.linkedIn),
    youTubeResult: Formality.exposeFieldResult(state.fieldsStatuses.youTube),
    tikTokResult: Formality.exposeFieldResult(state.fieldsStatuses.tikTok),
    yelpResult: Formality.exposeFieldResult(state.fieldsStatuses.yelp),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.twitter;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.facebook;
      if (typeof tmp$1 === "object") {
        return true;
      }
      let tmp$2 = match.instagram;
      if (typeof tmp$2 === "object") {
        return true;
      }
      let tmp$3 = match.linkedIn;
      if (typeof tmp$3 === "object") {
        return true;
      }
      let tmp$4 = match.youTube;
      if (typeof tmp$4 === "object") {
        return true;
      }
      let tmp$5 = match.tikTok;
      if (typeof tmp$5 === "object") {
        return true;
      }
      let tmp$6 = match.yelp;
      return typeof tmp$6 === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function UnifiedTeamAccountProfileSocialMediaSettings$InputField(props) {
  let result = props.result;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Label.make, {
          labelText: props.label
        }),
        className: "pt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Form__TextInput.make, {
            placeholderText: props.placeholder,
            onChange: props.onChange,
            onBlur: props.onBlur,
            status: FormalityUI.UIKitStatus.ofOptFieldResult(result),
            value: props.value
          }),
          JsxRuntime.jsx(FormalityUI.FieldValidationMessage.make, {
            messageToString: message => message,
            result: result
          })
        ],
        className: "mt-2 space-y-3 sm:col-span-2 sm:mt-0 sm:max-w-xs"
      })
    ],
    className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6"
  });
}

let InputField = {
  make: UnifiedTeamAccountProfileSocialMediaSettings$InputField
};

let convertVariables$1 = UnifiedTeamAccountProfileSocialMediaSettingsQuery_graphql.Internal.convertVariables;

let convertResponse$1 = UnifiedTeamAccountProfileSocialMediaSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = UnifiedTeamAccountProfileSocialMediaSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use$1 = RescriptRelay_Query.useQuery(convertVariables$1, UnifiedTeamAccountProfileSocialMediaSettingsQuery_graphql.node, convertResponse$1);

let useLoader = RescriptRelay_Query.useLoader(convertVariables$1, UnifiedTeamAccountProfileSocialMediaSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UnifiedTeamAccountProfileSocialMediaSettingsQuery_graphql.node, convertResponse$1, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UnifiedTeamAccountProfileSocialMediaSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let fetchPromised = RescriptRelay_Query.fetchPromised(UnifiedTeamAccountProfileSocialMediaSettingsQuery_graphql.node, convertResponse$1, convertVariables$1);

let retain = RescriptRelay_Query.retain(UnifiedTeamAccountProfileSocialMediaSettingsQuery_graphql.node, convertVariables$1);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$1,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function UnifiedTeamAccountProfileSocialMediaSettings(props) {
  let match = use$1(undefined, undefined, undefined, undefined);
  let profile = match.currentAccountV5.profile;
  switch (profile.__typename) {
    case "IndividualAccountProfile" :
      return JsxRuntime.jsx(Redirect.make, {
        path: "/account/account_profile"
      });
    case "TeamAccountProfile" :
      let socialAccounts = profile.socialAccounts;
      let match$1 = useSocials();
      let save = match$1[0];
      let form = useForm({
        twitter: Stdlib_Option.getOr(Stdlib_Option.flatMap(socialAccounts, accounts => accounts.twitter), ""),
        facebook: Stdlib_Option.getOr(Stdlib_Option.flatMap(socialAccounts, accounts => accounts.facebook), ""),
        instagram: Stdlib_Option.getOr(Stdlib_Option.flatMap(socialAccounts, accounts => accounts.instagram), ""),
        linkedIn: Stdlib_Option.getOr(Stdlib_Option.flatMap(socialAccounts, accounts => accounts.linkedIn), ""),
        youTube: Stdlib_Option.getOr(Stdlib_Option.flatMap(socialAccounts, accounts => accounts.youTube), ""),
        tikTok: Stdlib_Option.getOr(Stdlib_Option.flatMap(socialAccounts, accounts => accounts.tikTok), ""),
        yelp: Stdlib_Option.getOr(Stdlib_Option.flatMap(socialAccounts, accounts => accounts.yelp), "")
      }, (values, param) => {
        let notifyOnFailure = param.notifyOnFailure;
        let notifyOnSuccess = param.notifyOnSuccess;
        save({
          facebook: values.facebook,
          instagram: values.instagram,
          linkedIn: values.linkedIn,
          tikTok: values.tikTok,
          twitter: values.twitter,
          yelp: values.yelp,
          youTube: values.youTube
        }, payload => {
          if (payload === undefined) {
            return notifyOnFailure();
          }
          if (payload.__typename !== "TeamAccountProfile") {
            return notifyOnFailure();
          }
          let saved = payload.socialAccounts;
          if (saved !== undefined) {
            return notifyOnSuccess({
              twitter: Stdlib_Option.getOr(saved.twitter, ""),
              facebook: Stdlib_Option.getOr(saved.facebook, ""),
              instagram: Stdlib_Option.getOr(saved.instagram, ""),
              linkedIn: Stdlib_Option.getOr(saved.linkedIn, ""),
              youTube: Stdlib_Option.getOr(saved.youTube, ""),
              tikTok: Stdlib_Option.getOr(saved.tikTok, ""),
              yelp: Stdlib_Option.getOr(saved.yelp, "")
            });
          } else {
            return notifyOnFailure();
          }
        }, param => notifyOnFailure());
      });
      return JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(UnifiedProfileSettingsUI.SubpageHeader.make, {
            title: "Social Media",
            rootName: "Your Team's Profile",
            rootUrl: "/account/account_profile",
            url: "/account/account_profile/social_media"
          }),
          JsxRuntime.jsxs("form", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(UnifiedTeamAccountProfileSocialMediaSettings$InputField, {
                    label: "Twitter",
                    placeholder: "URL or username",
                    value: form.input.twitter,
                    onChange: event => form.updateTwitter((input, value) => ({
                      twitter: value,
                      facebook: input.facebook,
                      instagram: input.instagram,
                      linkedIn: input.linkedIn,
                      youTube: input.youTube,
                      tikTok: input.tikTok,
                      yelp: input.yelp
                    }), event.target.value),
                    onBlur: param => form.blurTwitter(),
                    result: form.twitterResult
                  }),
                  JsxRuntime.jsx(UnifiedTeamAccountProfileSocialMediaSettings$InputField, {
                    label: "Facebook",
                    placeholder: "URL or username",
                    value: form.input.facebook,
                    onChange: event => form.updateFacebook((input, value) => ({
                      twitter: input.twitter,
                      facebook: value,
                      instagram: input.instagram,
                      linkedIn: input.linkedIn,
                      youTube: input.youTube,
                      tikTok: input.tikTok,
                      yelp: input.yelp
                    }), event.target.value),
                    onBlur: param => form.blurFacebook(),
                    result: form.facebookResult
                  }),
                  JsxRuntime.jsx(UnifiedTeamAccountProfileSocialMediaSettings$InputField, {
                    label: "Instagram",
                    placeholder: "URL or username",
                    value: form.input.instagram,
                    onChange: event => form.updateInstagram((input, value) => ({
                      twitter: input.twitter,
                      facebook: input.facebook,
                      instagram: value,
                      linkedIn: input.linkedIn,
                      youTube: input.youTube,
                      tikTok: input.tikTok,
                      yelp: input.yelp
                    }), event.target.value),
                    onBlur: param => form.blurInstagram(),
                    result: form.instagramResult
                  }),
                  JsxRuntime.jsx(UnifiedTeamAccountProfileSocialMediaSettings$InputField, {
                    label: "LinkedIn",
                    placeholder: "https://www.linkedin.com/in/your-name",
                    value: form.input.linkedIn,
                    onChange: event => form.updateLinkedIn((input, value) => ({
                      twitter: input.twitter,
                      facebook: input.facebook,
                      instagram: input.instagram,
                      linkedIn: value,
                      youTube: input.youTube,
                      tikTok: input.tikTok,
                      yelp: input.yelp
                    }), event.target.value),
                    onBlur: param => form.blurLinkedIn(),
                    result: form.linkedInResult
                  }),
                  JsxRuntime.jsx(UnifiedTeamAccountProfileSocialMediaSettings$InputField, {
                    label: "YouTube",
                    placeholder: "URL or username",
                    value: form.input.youTube,
                    onChange: event => form.updateYouTube((input, value) => ({
                      twitter: input.twitter,
                      facebook: input.facebook,
                      instagram: input.instagram,
                      linkedIn: input.linkedIn,
                      youTube: value,
                      tikTok: input.tikTok,
                      yelp: input.yelp
                    }), event.target.value),
                    onBlur: param => form.blurYouTube(),
                    result: form.youTubeResult
                  }),
                  JsxRuntime.jsx(UnifiedTeamAccountProfileSocialMediaSettings$InputField, {
                    label: "TikTok",
                    placeholder: "URL or username",
                    value: form.input.tikTok,
                    onChange: event => form.updateTikTok((input, value) => ({
                      twitter: input.twitter,
                      facebook: input.facebook,
                      instagram: input.instagram,
                      linkedIn: input.linkedIn,
                      youTube: input.youTube,
                      tikTok: value,
                      yelp: input.yelp
                    }), event.target.value),
                    onBlur: param => form.blurTikTok(),
                    result: form.tikTokResult
                  }),
                  JsxRuntime.jsx(UnifiedTeamAccountProfileSocialMediaSettings$InputField, {
                    label: "Yelp",
                    placeholder: "URL or username",
                    value: form.input.yelp,
                    onChange: event => form.updateYelp((input, value) => ({
                      twitter: input.twitter,
                      facebook: input.facebook,
                      instagram: input.instagram,
                      linkedIn: input.linkedIn,
                      youTube: input.youTube,
                      tikTok: input.tikTok,
                      yelp: value
                    }), event.target.value),
                    onBlur: param => form.blurYelp(),
                    result: form.yelpResult
                  })
                ],
                className: "space-y-8 pb-12 sm:space-y-0 sm:divide-y sm:divide-zinc-200 sm:pb-0"
              }),
              JsxRuntime.jsx(UnifiedProfileSettingsUI.FormActions.make, {
                publicUrl: profile.publicUrl,
                saveDisabled: match$1[1] || form.submitting
              }),
              JsxRuntime.jsx("div", {
                children: match$1[2],
                className: "mt-4"
              })
            ],
            onSubmit: event => {
              event.preventDefault();
              form.submit();
            }
          })
        ],
        className: "space-y-8 rounded bg-white p-6 shadow-sm"
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected account profile member: ` + profile._0);
  }
}

let make = UnifiedTeamAccountProfileSocialMediaSettings;

exports.SocialsMutation = SocialsMutation;
exports.useSocials = useSocials;
exports.FormConfig = FormConfig;
exports.InputField = InputField;
exports.Query = Query;
exports.make = make;
/* commitMutation Not a pure module */
